<article class="expense-summary">
  <app-expense-receipt-thumbnail
    class="expense-summary__thumb"
    [url]="expense.receiptUrl"
  ></app-expense-receipt-thumbnail>

  <div class="expense-summary__body">
    <p class="expense-summary__category">
      {{ expense.category | expenseCategoryLabel }}
    </p>
    <p class="expense-summary__meta">
      <span *ngIf="expense.driverName">{{ expense.driverName }}</span>
      <span *ngIf="expense.driverName && expense.description">&middot;</span>
      <span *ngIf="expense.description">{{ expense.description }}</span>
      <span *ngIf="!expense.driverName && !expense.description">{{
        'expenses.no_value' | translate
      }}</span>
    </p>

    <div class="expense-summary__footer">
      <app-expense-status-badge
        [status]="expense.status"
      ></app-expense-status-badge>

      <!-- Sólo en gastos aprobados: antes de aprobar no hay decisión que mostrar. -->
      <span
        *ngIf="chargeback as badge"
        class="expense-summary__chargeback"
        [class.expense-summary__chargeback--exception]="!badge.isRebilled"
        [tuiHint]="badge.hintKey | translate"
        tuiHintDirection="top"
        tuiHintMode="onHover"
      >
        {{ badge.labelKey | translate }}
        <!-- SVG en línea y no el carácter ⓘ: el glifo cae en una fuente de respaldo y se ve pixelado. -->
        <svg
          class="expense-summary__chargeback-icon"
          viewBox="0 0 16 16"
          aria-hidden="true"
          focusable="false"
        >
          <circle
            cx="8"
            cy="8"
            r="7"
            fill="none"
            stroke="currentColor"
            stroke-width="1.4"
          />
          <circle cx="8" cy="4.7" r="0.9" fill="currentColor" />
          <line
            x1="8"
            y1="7"
            x2="8"
            y2="11.6"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linecap="round"
          />
        </svg>
      </span>

      <button
        *ngIf="canOpenDetail"
        type="button"
        class="expense-summary__link"
        (click)="openDetail.emit(expense)"
      >
        {{ 'expenses.view_detail' | translate }}
        <span aria-hidden="true">&#8594;</span>
      </button>
    </div>
  </div>

  <p class="expense-summary__amount">
    {{ expense.amountInCents | expenseAmount : expense.currencyCode : currencySymbol }}
  </p>
</article>
